export default __webpack_public_path__ + "static/StudiLive-720d93d2e8af5614a69db2dd8dd170e0.png";